import cx from 'classnames';
import { times } from 'lodash';
import moment from 'moment';
import { ELSButton } from '@els/els-component-button-react';
import { MarRecord } from 'models/ui';
import { DATE_FORMAT, DATE_FORMAT_MAR } from 'constants/app.constant';
import { ORDER_TYPES } from 'components/features/chart/mar/constants';
import { sortByDosageTime } from 'components/features/chart/mar/helper';
import './dosage-times-modal.scss';
import './modal.scss';

export interface DosageTimesModalProps {
  record: MarRecord;
  className?: string;
  chartingTime?: string;
  onClose: () => void;
}

const DosageTimesModal = (props: DosageTimesModalProps) => {
  const getDateRange = () => {
    const { orderStartDate, orderStopDate, orderType, route } = props.record;
    const isStat = orderType === ORDER_TYPES.STAT && route !== 'IV Infusion';
    if (isStat) {
      return [orderStartDate];
    }

    const orderStart = moment(orderStartDate).startOf('day');
    const orderStop = moment(orderStopDate).startOf('day');

    const chartStart = moment(props.chartingTime).startOf('day');
    const chartEnd = moment(props.chartingTime).add(9, 'days').startOf('day');

    const overlapStart = moment.max(orderStart, chartStart);
    const overlapEnd = moment.min(orderStop, chartEnd);

    if (overlapStart.isAfter(overlapEnd)) {
      return [];
    }

    const dayCount = overlapEnd.diff(overlapStart, 'days') + 1;

    return times(dayCount, (i) => overlapStart.clone().add(i, 'days').format(DATE_FORMAT));
  };

  const getTime = () => {
    if (props.record?.orderType === ORDER_TYPES.PRN) {
      return props.record?.orderStartTime;
    }
    return (
      sortByDosageTime(props.record?.originDosageTimes)
        ?.filter((item) => item.dosageDate === props.record?.dosageTimeTable)
        .map((item) => (item.dosageTime === 'Administer' ? props.record?.orderStartTime : item.dosageTime))
        .join(' | ') || props.record?.orderStartTime
    );
  };

  const formatDate = (date: string) => {
    return moment(date).format(DATE_FORMAT_MAR);
  };

  return (
    <div className={cx('dosage-times-modal', props.className)}>
      <h3>Dosage Schedule</h3>
      <div className="dosage-times-modal__name">{`Drug Name: ${props.record?.drugName}`}</div>
      <div className="dosage-times-modal__total">{`Total Dosage${getDateRange().length === 1 ? '' : 's'}: ${getDateRange().length}`}</div>
      <div className="dosage-times-modal__list">
        <div className="dosage-times-modal__list__header">
          <div>Date</div>
          <div>Dosage Time (s)</div>
        </div>
        {getDateRange().map((date) => (
          <div key={date} className="dosage-times-modal__list__item">
            <div>{formatDate(date)}</div>
            <div>{getTime()}</div>
          </div>
        ))}
      </div>
      <div className="dosage-times-modal__footer">
        <ELSButton text="Okay" onClick={props.onClose} />
      </div>
    </div>
  );
};

DosageTimesModal.displayName = 'DosageTimesModal';
export default DosageTimesModal;
